var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"parution-extrait"},[_c('GoBack'),_vm._v(" "+_vm._s(_vm.article.product.extrait.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }